import React, { useEffect, useCallback, useState } from 'react';
import { Redirect } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import { Tabs, Tab, Divider, Card, CardContent } from '@material-ui/core';
import { Page, Header } from 'components';
import Voice from './Voice/Voice';
import Packet from './Packet/Packet';

const tabs = [
	{ value: 'voice', label: 'voice' },
	{ value: 'packet', label: 'packet' },
];

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(1),
	},
	tabs: {
		marginTop: theme.spacing(1),
	},
	content: {
		marginTop: theme.spacing(1),
	},
}));

const Failures = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const [tab, setTab] = useState('voice');

	const getData = useCallback(() => {
		// dispatch();
	}, []);

	useEffect(() => {
		getData();
	}, []);

	const handleTabsChange = (event, value) => {
		setTab(value);
	};

	if (!tab) {
		return <Redirect to="/home" />;
	}

	if (!tabs.find((t) => t.value === tab)) {
		return <Redirect to="/errors/error-404" />;
	}

	return (
		<Page className={classes.root} title="Failures">
			<Header module="Modules" view="Failures" />
			<Card className={classes.container}>
				<CardContent>
					<Tabs
						className={classes.tabs}
						onChange={handleTabsChange}
						scrollButtons="auto"
						value={tab}
						variant="scrollable"
					>
						{tabs.map((t) => (
							<Tab key={t.value} label={t.label} value={t.value} />
						))}
					</Tabs>
					<Divider className={classes.divider} />
					<div className={classes.content}>
						{tab === 'voice' && <Voice />}
						{tab === 'packet' && <Packet />}
					</div>
				</CardContent>
			</Card>
		</Page>
	);
};

export default Failures;
